var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13428 4.39411V15.6095C2.13428 15.9813 2.28198 16.3379 2.54489 16.6008C2.8078 16.8637 3.16438 17.0114 3.5362 17.0114H17.5554C17.7413 17.0114 17.9196 16.9375 18.051 16.8061C18.1825 16.6746 18.2563 16.4963 18.2563 16.3104V6.49699C18.2563 6.31108 18.1825 6.13279 18.051 6.00133C17.9196 5.86988 17.7413 5.79603 17.5554 5.79603H3.5362C3.16438 5.79603 2.8078 5.64832 2.54489 5.38541C2.28198 5.1225 2.13428 4.76592 2.13428 4.39411ZM2.13428 4.39411C2.13428 4.02229 2.28198 3.66571 2.54489 3.4028C2.8078 3.13989 3.16438 2.99219 3.5362 2.99219H15.4525",
    stroke: "#28293D",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.401 12.4544C14.9817 12.4544 15.4525 11.9837 15.4525 11.403C15.4525 10.8223 14.9817 10.3516 14.401 10.3516C13.8204 10.3516 13.3496 10.8223 13.3496 11.403C13.3496 11.9837 13.8204 12.4544 14.401 12.4544Z",
    fill: "#28293D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/Billing.33582246a423319ed12669b0c6d09225.svg";
export { ForwardRef as ReactComponent };